{
  "screen": {
    "sectionHeading": "Patient details",
    "headingCorrect": "Correct patient details",
    "headingComplete": "Complete the patient details",
    "openCorrect": "Correct details",
    "openComplete": "Complete details",
    "explanationCorrect": "For details that were recorded wrongly. Covers the name, birth date and sex.",
    "explanationComplete": "For a patient identified after admission. Covers the name, birth date and sex.",
    "appendOnly": "The current version is not removed. What you save becomes a new version, and both stay in the record with who wrote them.",
    "identifierUnchanged": "The reservnummer and personnummer are not changed here. The band, the labels and earlier notes keep pointing at the same patient.",
    "requiredHint": "Fields with no note must be filled in.",
    "optional": "optional",
    "saveCorrect": "Save the correction",
    "saveComplete": "Save the details",
    "saving": "Saving …",
    "cancel": "Cancel",
    "close": "Close",
    "discardQuestion": "Close the form? What you have changed will not be saved.",
    "discardConfirm": "Close without saving",
    "discardCancel": "Keep filling in",
    "savedOk": "The details are saved.",
    "openPatient": "Back to the patient overview",
    "estimatedIdentity": "The identity is assumed, not established"
  },
  "fieldHint": {
    "isEstimatedIdentity": "Leave the box ticked for as long as the identity is an assumption. Clear it once you have established who the patient is — you are documenting your own judgement, the record makes no check of its own."
  },
  "refusal": {
    "versionStale": "Somebody else saved a new version of this patient's details while the form was open. The details shown are now the latest — check what you have typed and save again. What you wrote was not saved.",
    "noChange": "Nothing differs from what the record says. No new version was written.",
    "patientNotFound": "The patient is not in the record. The details were not saved.",
    "patientRetracted": "The patient is retracted in the record and cannot be given a new version. The details were not saved. Register a new patient instead if the details are needed.",
    "roleMayNotDocument": "Your role may not document in the record. The details were not saved.",
    "supersedesMissing": "The form does not know which version it is based on. Close the patient overview and open it again. The details were not saved.",
    "unknown": "The details were not saved. Try again.",
    "unavailable": "No contact with the server. The details were not saved — leave the form open and try again."
  }
}
